import { CurdDataSetConfig, FormFieldConfig, FormFieldType, Hardware } from '../types';
import { ChoiceTypes } from '@mri/enums';
import { SensorsConfigComponent } from '@mri/app/modules';
import { CommandsConfigComponent } from '../app/modules/commands-config';

const filterConfig: Array<FormFieldConfig> = [
  {
    key: 'name',
    label: 'Nombre',
    type: FormFieldType.STRING
  }
];
export const hardwareDataSetConfig: CurdDataSetConfig<Hardware> = {
  entityName: 'Equipo',
  collectionName: 'Hardware',
  gatewayUrl: 'hardware',
  baseBreadcrumb: 'hardware',
  form: {
    listRedirectUrl: 'console/system/hardware/list',
    fields: [
      {
        key: 'name',
        label: 'Nombre',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-12'
      },
      {
        key: 'image',
        image: value => value,
        label: 'Imagen',
        type: FormFieldType.IMAGE,
        containerClass: 'col-6 col-sm-6'
      },
      {
        key: 'description',
        label: 'Descripcion',
        type: FormFieldType.STRING,
        containerClass: 'col-12 col-sm-12'
      },
      {
        key: 'config.permitCommandKeys',
        label: 'Comando habilitados',
        type: FormFieldType.OPTIONS_MULTIPLE,
        containerClass: 'col-md-12 col-sm-12',
        optionsConfigKey: ChoiceTypes.COMMAND,
        fillValue: element => element?.config?.permitCommandKeys

      },
      {
        key: 'config.permitSensorKeys',
        label: 'Sensores habilitados',
        type: FormFieldType.OPTIONS_MULTIPLE,
        containerClass: 'col-md-12 col-sm-12',
        optionsGateway: 'sensors',
        fillValue: element => element?.config?.permitSensorKeys
      },
      {
        key: 'config.permitAlarmKeys',
        label: 'Alarmas soportadas',
        type: FormFieldType.OPTIONS_MULTIPLE,
        containerClass: 'col-md-12 col-sm-12',
        optionsConfigKey: ChoiceTypes.ALARM,
        fillValue: element => element?.config?.permitAlarmKeys
      }
    ]
  },
  list: {

    pageConfig: {
      title: 'Lista de equipos del sistema',
      breadcrumb: [
        {
          title: 'Sistema',
          type: 'item',
          link: '/console/system/hardware/list'
        },
        {
          title: 'Equipos',
          type: 'item',
          link: '/console/system/hardware/list'
        },
        {
          title: 'Lista',
          type: 'item',
          link: '/console/system/units/list',
          pageName: 'Equipos del sistema'
        }
      ]
    },
    filter: filterConfig,
    searchFilter: filterConfig,
    table: {
      columns: [
        { key: 'name', label: 'Nombre' },
        { key: 'deviceCount', label: 'Numero de dispositivos', getValue: prop => prop.element?.devices?.length.toString() || '0' },

        { key: 'protocols', label: 'Protocolos', getValue: prop =>
            [...new Set(prop.element?.devices?.map( d => d.protocol))]
              .filter(p => !!p)
              .map( p => `<span class="badge">${p}</span>`)
              .join(' ')
        },
        { key: 'description', label: 'Descripcion' }
      ]
    },
    actionsKeys: ['create', 'edit', 'delete'],
    extraActions: [
      {
        key: 'sensors-config',
        label: 'Configurar sensores',
        icon: 'fi-rr-bolt',
        onlyIcon: () => true,
        disableWhen: prop => prop.selectedElements?.length !== 1,
        click: ({ selectedElements, component }) => {
          const [element] = selectedElements || [];

          component?.openDrawer(
            `Configurar sensores de ${element.name}`,
            SensorsConfigComponent,
            { hardwareId: element._id }
          );
        }
      },
      {
        key: 'commands-config',
        label: 'Personalizar comandos',
        icon: 'fi fi-rr-comment',
        onlyIcon: () => true,
        disableWhen: prop => prop.selectedElements?.length !== 1,
        click: ({ selectedElements, component }) => {
          const [element] = selectedElements || [];

          component?.openDrawer(
            `Personalizar comandos de ${element.name}`,
            CommandsConfigComponent,
            { hardwareId: element._id }
          );
        }
      }
    ]
  },
  pages: ['list', 'edit', 'create']
};
